import React from "react";
import Sidebar from "../sidebar/Sidebar";
import FeaturedPost from "../featuredPost/FeaturedPost";

const MainContent = ({ featuredPost }) => {
  return (
    <div className="d-flex flex-column flex-md-row">
      <div className="col-md-8 px-2">
        <FeaturedPost ft={featuredPost} />
      </div>

      <div className="col-md-4 px-2">
        <Sidebar />
      </div>
    </div>
  );
};

export default MainContent;
